(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/containers/hidden-route.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/containers/hidden-route.js');
"use strict";

const {
  matchPath
} = svs.app.ReactRouter;
setGlobal('svs.tickets.play.containers.HiddenRoute', _ref => {
  let {
    url,
    displayPath,
    children
  } = _ref;
  const isMatch = matchPath(url, {
    path: displayPath,
    exact: true,
    strict: false
  });
  return React.createElement("div", {
    className: "min-height-wrapper",
    style: {
      display: isMatch ? '' : 'none'
    }
  }, children);
});

 })(window);